import dynamic from 'next/dynamic';
import { ModalCTAProps } from './ModalCTA.types';

export const ModalCTA = dynamic<ModalCTAProps>(() => import('./ModalCTA').then(module => module.ModalCTA));
